module.exports = __webpack_public_path__ + "static/media/right-caret-arrow.f7d4b09c.svg";